<template>
  <div>
    <LoggedInLayout v-if="isLoggedIn" :guide="guide"/>
    <LoggedOutLayout v-else />
  </div>
</template>

<script>
import LoggedInLayout from "@/layouts/LoggedInLayout";
import LoggedOutLayout from "@/layouts/LoggedOutLayout";
import { mapGetters } from "vuex";
import { getConsent } from '@/utils/consent'
import API from '@/services/api'

// @group Common
// Start component
export default {
  name: 'Start',
  props: {
    guide: {
      default: false,
      type: Boolean
    }
  },

  watch: {
    currentUser: {
      immediate: true,
      handler(user) {
        if (!user || !this.isLoggedIn) return

        const consent = getConsent()

        if (consent === null) return

        const allowAnalytics = consent === 'accepted'

        if (user.allowAnalytics === allowAnalytics) return

        API.setUser({
          ...user,
          allowAnalytics
        })
          .then(response => {
            this.updateCurrentUserData(response.data)
          })
          .catch((error) => {
            console.log(error);
          })
      }
    }
  },

  computed: {
    ...mapGetters("app", ["isInitialized"]),
    ...mapGetters("currentuser", ["currentUser", "isLoggedIn"])
  },

  components: {
    LoggedInLayout,
    LoggedOutLayout
  },

}
</script>

<style>

</style>